import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import classNames from 'classnames';
import { ReactComponent as CompanyIcon } from 'assets/icons/business-outlined.svg';
import React from 'react';
import styles from './PageSwitcher.module.css';

type Props = {
  facebookPage?: EnhancedBillingPage;
  onMenuClick: () => void;
  isMobile?: boolean;
};

export const PageSwitcher = (props: Props) => {
  const { facebookPage, onMenuClick, isMobile } = props;

  if (!facebookPage) {
    return <></>;
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.mobileWrapper]: isMobile,
      })}
      onClick={onMenuClick}
    >
      <CompanyIcon className={styles.companyIcon} />
      {!isMobile && <div className={styles.pageName}>{facebookPage.name}</div>}
    </div>
  );
};
